// extracted by mini-css-extract-plugin
export default {"active":"w9iososD28Kt_I5Cb3P2","inactive":"ddXjlOCBYW_yWNtjXeqO"};